export default {
      id: "i-flag-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-flag",
      toString: function () {
        return this.url;
      }
    }